<p-dialog [(visible)]="showDialogSearch" [modal]="true" [responsive]="true"
          [style]="{width: '80vw', maxWidth: '1152px'}"
          [baseZIndex]="10000" [closeOnEscape]="true" [dismissableMask]="true" (onHide)="closeDialog()" (onShow)="dialogOpened()">
    <ng-template pTemplate="content">
        <div class="search-content">
            <h2>¿Qué tipo de propiedad buscas?</h2>
            <div class="property-type-icons">
                <div *ngFor="let type of (facade.segments$ | async)" class="property-icon" (click)="onSegmentSelect(type.segmentId)"
                     [ngClass]="{'selected-segment': selectedSegmentId === type.segmentId}">
                    <img [src]="type.icon" alt="{{ type.label }}" class="icon-image">
                    <p>{{ type.label }}</p>
                </div>
            </div>

            <h2>¿Qué quieres hacer?</h2>
            <div class="action-buttons">
                <button *ngFor="let action of (facade.offers$ | async)"
                        pButton type="button"
                        [label]="action.label"
                        [ngStyle]="{'background-color': selectedOfferId === action.adId ? 'black' : action.color, 'color': 'white'}"
                        class="action-button"
                        (click)="selectOffer(action.adId, $event)">
                </button>
            </div>
            <h2>¿En qué departamento estás buscando?</h2>
            <div class="departments">
                <div *ngFor="let department of (facade.departments$ | async)"
                     class="department"
                     (click)="onDepartmentSelect(department.code)"
                     [ngClass]="{'selected-department': selectedDepartment === department.code}"
                     (mouseover)="hoveredDepartment = department.code"
                     (mouseleave)="hoveredDepartment = null"
                     [ngStyle]="{'border-color': hoveredDepartment === department.code ? 'black' : (selectedDepartment === department.code ? '#b1c282' : '#ccc')}">

                    <img class="img" [src]="department.image" alt="{{ department.name }}">
                    <p [ngStyle]="{'font-weight': hoveredDepartment === department.code ? 'bold' : 'normal'}">
                        {{ department.name }}
                    </p>
                </div>
            </div>
            <div class="city-neighborhood">
                <div class="dropdown-group">
                    <h2>¿En qué ciudad?</h2>
                    <p-dropdown [options]="(facade.cities$ | async) ?? []"
                                [(ngModel)]="selectedCity"
                                [disabled]="!selectedDepartment"
                                optionLabel="label"
                                placeholder="Seleccione la ciudad"
                                (onChange)="onCityChange($event)"></p-dropdown>

                    <h2>¿En qué barrio?</h2>
                    <p-dropdown [options]="(facade.zones$ | async) ?? []"
                                [(ngModel)]="selectedNeighborhood"
                                [disabled]="!selectedCity"
                                optionLabel="label"
                                placeholder="Seleccione el barrio"
                                (onChange)="onNeighborhoodChange($event)"></p-dropdown>

                </div>
                <div class="map" *ngIf="dialogVisible">
                    <div class="map">
                        <google-map
                            height="100%"
                            width="100%"
                            [center]="center"
                            [zoom]="zoom"
                            (centerChanged)="onCenterChanged()"
                            (mapClick)="addMarker($event)"
                            #mapRef>
                            <map-marker
                                *ngIf="center"
                                [position]="center"
                                [options]="markerOptions">
                            </map-marker>
                            <map-circle
                                *ngIf="center"
                                [center]="center"
                                [radius]="650"
                                [options]="circleOptions">
                            </map-circle>
                        </google-map>
                    </div>
                </div>
            </div>
            <div class="budget-content">
                <h2>¿Cuál es tu presupuesto? <i class="pi pi-exclamation-triangle" style="color: #E1A000;"></i></h2>
                <p>Selecciona tu rango de precio de búsqueda</p>
            </div>
            <div class="budget-section">
                <!-- Slider de rango -->
                <div class="budget-slider">
                    <p-slider [(ngModel)]="priceRange" [style]="{width: '100%'}" [range]="true" [min]="0"
                              [max]="100000"></p-slider>
                </div>

                <!-- Inputs de mínimo y máximo -->
                <div class="price-inputs">
                    <div class="input-group">
                        <label>Mínimo (Bs.)</label>
                        <div class="flex flex-row">
                            <input pInputText type="text"
                                   placeholder="$ 0 USD"
                                   [value]="getFormattedValue(priceRange[0])"/>
                        </div>
                    </div>
                    <div class="input-group">
                        <label>Máximo (Bs.)</label>
                        <div class="flex flex-row">
                            <input pInputText type="text" placeholder="$ 10,000,000+ USD"
                                   [value]="getFormattedValue(priceRange[1])"/>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="footer-button-container" *ngIf="errorMessage">
            <div class="error-message">
                {{ errorMessage }}
            </div>
        </div>
        <div class="footer-button-container">
            <button pButton pRipple type="button" (click)="submitSearch()">
                <span class="px-4">Buscar</span>
                <i class="pi pi-arrow-right custom-arrow-right-icon"></i>
            </button>
        </div>
    </ng-template>

</p-dialog>
